(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["favy-intro"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function() {
const slider = document.querySelector('.video-slider-track');

  const bar = document.getElementById('scroll-bar');
  const progress = document.querySelector('.scroll-progress');

  function updateProgress() {
    const maxScroll = slider.scrollWidth - slider.clientWidth;
    const scrollLeft = slider.scrollLeft;

    if (maxScroll <= 0) {
      bar.style.width = "100%";
      bar.style.transform = "translateX(0)";
      return;
    }

    const maxTranslate = progress.clientWidth - bar.offsetWidth;
    const percentage = scrollLeft / maxScroll;
    const translateX = percentage * maxTranslate;

    bar.style.transform = `translateX(${translateX}px)`;
  }

  slider.addEventListener('scroll', updateProgress);
  window.addEventListener('resize', updateProgress);
  updateProgress();
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
